export default [
	{
		name: 'AdminUsers',
		path: 'users',
		component: () => import('@/pages/admin/components/user/Users'),
	},
	{
		path: 'user/create',
		name: 'CreateUser',
		component: () => import('@/pages/admin/components/user/CreateUser'),
	},
	{
		path: 'user/:userId/edit',
		name: 'EditUser',
		component: () => import('@/pages/admin/components/user/EditUser'),
	},
	{
		path: 'user/:userId/enrolments',
		name: 'EnrolmentsUser',
		component: () => import('@/pages/admin/components/user/EnrolmentsUser'),
	},
	{
		path: 'user/:userId/enrolment/create',
		name: 'CreateEnrolment',
		component: () => import('@/pages/admin/components/user/CreateEnrolment'),
	},
	{
		path: 'user/:userId/enrolment/:enrolmentId/edit',
		name: 'EditEnrolment',
		component: () => import('@/pages/admin/components/user/EditEnrolment'),
	},
];
